export { SearchAsYouTypeMinimalistic } from './SearchAsYouTypeMinimalistic';
